import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../logo-quadrato.png";

export default function MarketingNavbar() {

  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <nav className="hp-nav">

      <img
        src={logo}
        alt="QrMenu-Italia"
        className="hp-nav-logo"
        onClick={() => navigate("/")}
        style={{ cursor: "pointer" }}
      />
<button
  className="hp-nav-mobile-btn"
  onClick={() => setMobileOpen(!mobileOpen)}
>
  ☰
</button>

      <div className={`hp-nav-links ${mobileOpen ? "open" : ""}`}>

        <button
          className="hp-nav-ghost"
          onClick={() => {
  navigate("/");
  setMobileOpen(false);
}}
        >
          Home
        </button>

<button
  className="hp-nav-ghost"
  onClick={() => {
    navigate("/piani");
    setMobileOpen(false);
  }}
>
  Piani
</button>

<button
  className="hp-nav-ghost"
  onClick={() => {
    navigate("/menu-digitale-ristoranti");
    setMobileOpen(false);
  }}
>
  Ristoranti e Pizzerie
</button>

 <button
  className="hp-nav-ghost"
  onClick={() => {
    navigate("/street-food");
    setMobileOpen(false);
  }}
>
  Street Food
</button>

        <button
          className="hp-nav-ghost"
          onClick={() => {
  navigate("/menu-ai");
  setMobileOpen(false);
}}
        >
          AI
        </button>

<button
  className="hp-nav-ghost"
  onClick={() => {
  navigate("/app-asporto");
  setMobileOpen(false);
}}
>
  Asporto
</button>

        <button
          className="hp-nav-demo"
          onClick={() => {
  navigate("/demo");
  setMobileOpen(false);
}}
        >
          Prova Gratis
        </button>

        <button
          className="hp-nav-cta"
          onClick={() => {
  navigate("/login");
  setMobileOpen(false);
}}
        >
          Accedi
        </button>

      </div>

    </nav>
  );
}